import { motion } from "motion/react";
import { Coffee, Scissors, ShoppingBag } from "lucide-react";
import { Button } from "./ui/button";

const industries = [
  {
    icon: Coffee,
    title: "例）飲食店",
    description: "現金以外の選択肢提示で来店率UP",
    benefits: [
      "現金以外の選択肢を明示",
      "電子マネー導入で若年層へのアプローチ",
      "外国人観光客にカード対応をアピール",
    ],
    gradient: "from-orange-500 to-red-500",
  },
  {
    icon: Scissors,
    title: "例）美容・サロン",
    description: "決済方法の選択肢を幅広い層へ宣伝",
    benefits: [
      "PayPayなどのQRコード決済対応明示で若者を取り込む",
      "クレジットカード，電子マネーの種類を明確化",
      "クレジットカードブランド，タッチ決済の可否を明示",
    ],
    gradient: "from-pink-500 to-purple-500",
  },
  {
    icon: ShoppingBag,
    title: "小売・物販",
    description: "海外カードOKの明記でインバウンドに",
    benefits: [
      "クレジットカードの各種国際ブランドを明示",
      "タッチ決済対応もアピール",
      "電子マネー対応で来店率アップ",
    ],
    gradient: "from-blue-500 to-cyan-500",
  },
];

export function IndustrySpecific() {
  return (
    <section className="py-24 bg-background relative overflow-hidden">
      <div className="absolute top-0 left-0 w-96 h-96 bg-purple-600/5 rounded-full blur-3xl" />
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="px-4 py-2 rounded-full bg-gradient-to-r from-purple-600/20 to-blue-600/20 border border-purple-600/30 text-purple-600">
            業種別活用法
          </span>
          <h2 className="mt-6 bg-gradient-to-r from-foreground to-foreground/70 bg-clip-text text-transparent">
            どの業種でも簡単にキャッシュレス対応を宣伝できます
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-muted-foreground">
            決済方法のアピールは来店・予約率アップに直結
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {industries.map((industry, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-card border border-border rounded-2xl p-8 hover:shadow-xl transition-all group"
            >
              <div className={`inline-flex p-4 rounded-xl bg-gradient-to-r ${industry.gradient} mb-6`}>
                <industry.icon className="text-white" size={32} />
              </div>

              <h3 className="mb-3">{industry.title}</h3>
              <p className="text-muted-foreground mb-6">{industry.description}</p>

              <div className="space-y-3 mb-6">
                {industry.benefits.map((benefit, idx) => (
                  <div key={idx} className="flex items-start gap-2">
                    <div className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-gradient-to-r from-purple-600 to-blue-600 mt-2" />
                    <span className="text-sm text-foreground/80">{benefit}</span>
                  </div>
                ))}
              </div>

              <Button variant="outline" disabled className="w-full">
                新規登録受付終了
              </Button>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <p className="text-muted-foreground">
            その他の業種でも、対応決済を明示することで来店数をアップできます
          </p>
        </motion.div>
      </div>
    </section>
  );
}
